/** Uzbek strings of channel pause, comment hiding, campaign totals and the transfer strategy (Wave 2). */
export const uzChannelsW2 = {
  "channelsW2.paused": "Pauzada",
  "channelsW2.pause": "Pauza",
  "channelsW2.resume": "Davom ettirish",
  "channelsW2.pauseTitle": "Kanal pauzaga qo'yilsinmi?",
  "channelsW2.pauseBody":
    "Bu akkaunt xabar yubormaydi va AI unda javob yozmaydi. Kiruvchi xabarlar kelishda davom etadi. Navbatdagi xabarlar kutib turadi va yoqilganda yuboriladi.",
  "channelsW2.pauseConfirm": "Pauzaga qo'yish",
  "channelsW2.cancel": "Bekor qilish",
  "channelsW2.failed": "Bajarib bo'lmadi. Qaytadan urinib ko'ring.",

  "channelsW2.held.label": "Yuborilmagan xabarlar",

  "channelsW2.comment.hide": "Yashirish",
  "channelsW2.comment.suggested": "Spam: yashirish taklif qilinadi",
  "channelsW2.comment.hidden": "Instagram'da yashirilgan",
  "channelsW2.comment.hideFailed": "Kommentni yashirib bo'lmadi.",

  "channelsW2.campaign.audience": "Auditoriya",
  "channelsW2.campaign.sent": "Yuborildi",
  "channelsW2.campaign.failed": "Xato",
  "channelsW2.campaign.skipped": "O'tkazildi",
  "channelsW2.campaign.pending": "Kutmoqda",
  "channelsW2.campaign.pause": "Pauza",
  "channelsW2.campaign.resume": "Davom ettirish",

  "settings.choice.stay_on_instagram": "Instagram'da qolish",
  "settings.choice.invite_after_qualification": "Kvalifikatsiyadan keyin taklif",
  "settings.choice.redirect_now": "Darhol Telegram'ga",
  "settings.choice.ask_phone": "Telefon raqamini so'rash",
} as const;
